import {
  TableSortAscendingIcon,
  TableSortDescendingIcon,
} from '@diligentcorp/atlas-react-icons';
import { Box, Stack } from '@mui/material';

type Props = {
  isAscending?: boolean;
  isDescending?: boolean;
};

export function GridSortableHeader({ isAscending, isDescending }: Props) {
  if (isAscending) {
    return (
      <Stack>
        <TableSortDescendingIcon />
      </Stack>
    );
  }

  if (isDescending) {
    return (
      <Stack>
        <TableSortAscendingIcon />
      </Stack>
    );
  }

  return (
    <Stack>
      <Box sx={{ '& path': { opacity: 0.5 } }}>
        <TableSortAscendingIcon />
      </Box>
    </Stack>
  );
}
